import styled from 'styled-components';
import Button from '../Button';
import {primaryColor} from '../../config/colors';

export const ModalBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-width: 80%;
`;

export const Title = styled.h2`
  margin: 0;
  margin-bottom: 20px;
`;

export const Description = styled.p`
  margin: 0;
  margin-bottom: 20px;
`;

export const FileInput = styled.input`
  margin-bottom: 20px;
`;

export const FileName = styled.div`
  font-size: 0.8em;
  display: inline-flex;
  margin-left: 2em;
`;

export const Progress = styled.div`
  margin: 20px 0px;
  width: 100%;
  height: 10px;
  background: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    width: ${props => props.progress}%;
    height: 100%;
    background: #76c7c0;
  }
`;

export const ModalButton = styled(Button).attrs({
  wrapperStyle: {
    width: 'auto',
    height: '25px',
    marginLeft: '5px',
    display: 'inline-block',
  },
  type: 'rounded',
  textStyle: {
    fontSize: '0.8rem',
    margin: '0px 20px',
  },
})``;

export const TemplateLink = styled.span`
  cursor: pointer;
  color: ${primaryColor};
`;

export const ErrorMessage = styled.div`
  font-size: smaller;
  color: darkred;
  margin: 0.8em;
`;
